import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  typography = tokens.typography;
export var articleCard = {
  name: "1hkl4n",
  styles: "width:100%;border-radius:3px;overflow:hidden;min-height:124px;display:flex;align-items:stretch;"
};
export var link = /*#__PURE__*/css("flex-grow:1;flex-direction:column;display:flex;text-decoration:none;color:", colors.neutral.heavy.default, ";align-items:center;");
export var content = {
  name: "1y2exxf",
  styles: "display:flex;justify-content:space-between;align-items:stretch;flex-grow:1;"
};
export var topImageContainer = {
  name: "4wmrjl",
  styles: "display:block;height:200px;width:100%;img{width:100%;height:100%;object-fit:cover;}"
};
export var tags = {
  name: "1krlz36",
  styles: "display:flex;flex-wrap:wrap;overflow:hidden;max-height:24px;align-self:flex-start;gap:8px;"
};
export var tag = {
  name: "qau5kf",
  styles: "margin:0;text-shadow:none;"
};
export var middle = {
  name: "1f9c802",
  styles: "display:flex;flex-direction:column;flex-grow:1;gap:8px;padding:16px 0;"
};
export var heading = /*#__PURE__*/css(applyFont(typography.subheading), " ", truncateLines(2));
var bodyLongLineHeight = 24;
export var description = _ref => {
  var fixedHeight = _ref.fixedHeight,
    maxLines = _ref.maxLines;
  return /*#__PURE__*/css(truncateLines(maxLines), " ", applyFont(typography.body), " line-height:", bodyLongLineHeight, "px;color:", colors.neutral.heavy.default, ";margin-bottom:16px;", fixedHeight && /*#__PURE__*/css("height:", maxLines * bodyLongLineHeight, "px;"));
};
export var arrow = {
  name: "1p57ph1",
  styles: "padding-top:16px;padding-right:10px;"
};